export enum FDRStatus {
  canEngage = 'canEngage',
  agreementComplete = 'agreementComplete',
  agreementPending = 'agreementPending',
  eligibleForEnrollment = 'eligibleForEnrollment',
  availableForEnrollment = 'availableForEnrollment',
  contracted = 'contracted',
  completed = 'completed',
  enrolled = 'enrolled',
  enrolling = 'enrolling',
  futureEnrollment = 'futureEnrollment',
  futureProgram = 'futureProgram',
  hasOffer = 'hasOffer',
  hasOpportunity = 'hasOpportunity',
  hasReward = 'hasReward',
  historicalProgram = 'historicalProgram',
  ineligibleForEnrollment = 'ineligibleForEnrollment',
  // not being accepted by backend
  // isEnrolled = 'isEnrolled',
  isEngaged = 'isEngaged',
  needsInfo = 'needsInfo',
  postEnrollNoActionNeeded = 'postEnrollNoActionNeeded',
  profileIncomplete = 'profileIncomplete',
  readyToEnroll = 'readyToEnroll',
  remoteSensingResolved = 'remoteSensingResolved',
  rewardsResolved = 'rewardsResolved',
  ruleIneligible = 'ruleIneligible',
  underReview = 'underReview',
  overlapsField = 'overlapsField',
  overlapsCommitted = 'overlapsCommitted',
  overlapsSameOwner = 'overlapsSameOwner',
}

export type FDRStatsQueryItem = {
  status: FDRStatus
  programId?: string
  sort?: {
    sortDir: 'asc' | 'desc'
    // path to the value used to sort response items.
    // eg. ["acres"], ["fields"], ["rewards", "opportunities", "usd", "amount"]
    // ["rewards", "opportunities", "carbonCredit", "amount"]
    value: ['fields']
  }
}

export interface FDRStatusEntry {
  status: FDRStatus[]
  programId: string
}

export interface FDRStatusQuery {
  status: FDRStatus
  programId?: string
  isNegated?: boolean
}
